// src/features/summary/teamService.js
import api from "../../api/api";

/**
 * Ambil data summary counts dari endpoint /summary/counts
 * @returns {Promise<Object>} - Data summary dari API
 */
const fetchTeams = async () => {
  const response = await api.get("/teams");
  return response.data;
};

const teamService = {
  fetchTeams,
};

export default teamService;
